<template>
	<div class="header-components">
		<div class="web-wrapper" :class="{ 'is-fixed': isAppsFixed }">
			<div class="web">
				<div class="left-wrapper">
					<div class="logo" @click="goPage('/')">
						<img src="@/assets/logo-new-20250214.png" />
					</div>
					<div class="nav">
						<div class="nav-items" v-for="(item, index) in navList" :key="index" @click="goPage(item.path)">
							<span>{{ (currentLanguage === 'zh') ? item.meta.title_zh : item.meta.title_en }}</span>
						</div>
					</div>
				</div>
				<div class="right-wrapper">
					<button class="switch-zh" :class="(currentLanguage === 'zh') ? 'current-language' : ''"
						@click="changeLanguageClick('zh')">简体中文</button>
					<button class="switch-en" :class="(currentLanguage === 'en') ? 'current-language' : ''"
						@click="changeLanguageClick('en')">English</button>
				</div>
			</div>
		</div>

		<div class="apps" :class="{ 'is-fixed': isAppsFixed }">
			<div class="logo" @click="goPage('/')">
				<img src="@/assets/logo-new-20250214.png" />
			</div>
			<div class="nav" :class="{ active: showNavList }" @click="showNavListClick()">
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
		<el-drawer :visible.sync="showNavList" direction="ltr" :withHeader="false">
			<div class="apps-nav">
				<div class="logo" @click="goPage('/')">
					<img src="@/assets/logo-new-20250214.png" />
				</div>
				<div class="nav">
					<div class="nav-items" v-for="(item, index) in navList" :key="index" @click="goPage(item.path)">
						<span>{{ (currentLanguage === 'zh') ? item.meta.title_zh : item.meta.title_en }}</span>
					</div>
				</div>
				<div class="switch">
					<span :class="(currentLanguage === 'zh') ? 'current-language' : ''"
						@click="changeLanguageClick('zh')">简体中文</span>
					<span> &nbsp; / &nbsp; </span>
					<span :class="(currentLanguage === 'en') ? 'current-language' : ''"
						@click="changeLanguageClick('en')">English</span>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import {
	changeLanguage
} from '@/util/lang'
import router, {
	constantRoutes
} from '@/router'
export default {
	name: 'Header',
	data() {
		return {
			navList: [],
			showNavList: false,
			isAppsFixed: false,
		}
	},
	created() {
		this.init()
	},
	computed: {
		// 当前语言
		currentLanguage() {
			return this.$store.state.language.currentLanguage
		}
	},
	methods: {
		// 初始化
		init() {
			this.navList = constantRoutes.filter(item => !item.hidden);
		},
		handleScroll() {
			this.isAppsFixed = window.scrollY > 0;
		},
		// 跳转页面
		goPage(path) {
			this.$router.push(path)
			this.showNavList = false
		},
		// 切换语言
		changeLanguageClick(language) {
			changeLanguage(language)
			this.$i18n.locale = language;
			this.$store.dispatch("setCurrentLanguage", language)
			// 添加时间戳作为查询参数，强制路由更新
			router.push({ path: router.currentRoute.path, query: { t: Date.now() } })
		},
		// 导航栏列表展示
		showNavListClick() {
			this.showNavList = !this.showNavList
		},
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	}
}
</script>

<style lang="scss">
/*  笔记本电脑样式 */
.header-components {


	.web-wrapper {
		@include flex(center);
		border-bottom: 1px solid #f0f0f0;
		background-color: #ffffff;

		&.is-fixed {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			z-index: 10086;
			
		}
	}

	.web {
		@include flex(space-between);
		margin: 25px 0px;

		.left-wrapper {
			@include flex(space-between, center);

			.logo img {
				margin-right: 15px;
				width: 135px;
				// height: 25px;
			}

			.nav {
				@include flex;
				color: #101010;
				font-size: 18px;
				
				.nav-items {
					padding: 0px 20px;

					&:hover {
						color: $main-color;
					}
				}
			}
		}

		.right-wrapper {
			@include flex(right, center);
			width: 400px;

			.current-language {
				background-color: $main-color !important;
				color: #FFFFFF !important;
			}

			.switch-zh,
			.switch-en {
				padding: 3px 12px;
				border: 1px solid $main-color;
				border-radius: 25px;
				font-size: 14px;
				background-color: #ffffff;
				color: $main-color;

				&:hover {
					background-color: $main-color;
					color: #FFFFFF;
				}
			}

			.switch-zh {
				margin-right: 8px;
			}
		}
	}

	.apps {
		display: none;
	}
}

/* 超大屏幕样式 */
@media only screen and (min-width: 1550px) {

	.header-components {
		.web {
			margin: 45px 0px;

			.left-wrapper {
				.logo img {
					margin-right: 15px;
					width: 176px;
					// height: 27.5px;
				}

				.nav {
					font-size: 20px;

					.nav-items {
						padding: 0px 35px;
					}
				}
			}

			.right-wrapper {
				width: 400px;

				.switch-zh,
				.switch-en {
					padding: 4px 18px;
					font-size: 14px;
				}

				.switch-zh {
					margin-right: 14px;
				}
			}
		}
	}
}

/* 手机样式 */
@media only screen and (max-width: 767px) {
	.header-components {
		position: relative;

		.web {
			display: none;
		}

		.apps {
			position: sticky;
			top: 0;
			z-index: 10;
			@include flex(space-between, center);
			padding: 20px 15px;
			background-color: #ffffff;

			&.is-fixed {
				position: fixed;
				top: 0;
				left: 0;
				right: 0;
			}

			.logo img {
				width: 90px;
				// height: 18px;
			}

			.nav {
				@include flex($direction: column);

				span {
					width: 1.5em;
					height: 0.15em;
					margin: 0.15em 0;
					border-radius: 5px;
					background-color: #303133;
					transition: transform 0.3s, opacity 0.3s;
				}

				&.active span {
					&:nth-child(1) {
						transform: rotate(45deg) translate(0, 9px);
					}

					&:nth-child(2) {
						opacity: 0;
					}

					&:nth-child(3) {
						transform: rotate(-45deg) translate(0, -9px);
					}
				}
			}
		}

		.el-drawer {
			width: 60% !important;
		}

		.apps-nav {
			padding: 20px 15px;
			background-color: #ffffff;

			.logo img {
				width: 90px;
				height: 18px;
			}

			.nav {
				margin-top: 45px;

				.nav-items {
					padding: 0px 0px 20px 10px;
				}
			}

			.switch {
				position: absolute;
				bottom: 50px;
				padding-left: 10px;
				font-size: 13px;

				.current-language {
					color: $main-color;
					font-size: 16px;
				}
			}
		}
	}
}
</style>